module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceImageRenderModule",
    "path": "front/piece-image-render.module"
  },
  "cms-module": {
    "name": "PieceImageCmsModule",
    "path": "front/piece-image-cms.module"
  },
  "definition": {
    "type": "image",
    "name": "PieceImageDefinition",
    "group": "Media",
    "availablePlatforms": ["web", "apps"],
    "description": "Imagen",
    "fields": [
      {
        "name": "Image",
        "type": "linkedImages",
        "mandatory": true
      },
      {
        "name": "impolicy",
        "type": "options",
        "label": "Akamai Impolicy",
        "defaultValue": "",
        "values": [],
        "isExcluded": true
      },
      {
        "name": "preloadImage",
        "label": "Precargar imagen en SSR",
        "type": "boolean",
        "defaultValue": false,
        "isExcluded": true
      },
      {
        "name": "title",
        "label": "Título (title)",
        "placeholder": "Title (SEO)",
        "type": "plainText"
      },
      {
        "name": "alt",
        "label": "Texto alternativo (Alt)",
        "placeholder": "Texto alternativo (accesibilidad)",
        "type": "plainText"
      },
      {
        "label": "Enlace",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "link",
            "label": "Url de destino",
            "type": "link"
          }
        ]
      },
      {
        "label": "Avanzado",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "theme",
            "type": "options",
            "label": "Tema",
            "defaultValue": "light",
            "values": [
              {
                "label": "Claro",
                "value": "light"
              },
              {
                "label": "Oscuro",
                "value": "dark"
              },
              {
                "label": "Blend",
                "value": "blend"
              },
            ]
          }
        ]
      },
      {
        "name": "objectPosition",
        "label": "Posición de la imagen",
        "type": "options",
        "section": "styles",
        "defaultValue": "center",
        "values": [
          { "value": "center", "label": "Centro" },
          { "value": "top", "label": "Arriba" },
          { "value": "bottom", "label": "Abajo" }
        ]
      },
      {
        "name": "objectFit",
        "label": "Proporción de la imagen",
        "type": "options",
        "section": "styles",
        "defaultValue": "cover",
        "values": [
          { "value": "contain", "label": "Contain" },
          { "value": "cover", "label": "Cover" }
        ]
      }
    ],
    "analytics": [
      "click-image"
    ]
  }
};
